import {
  createElementVNode as _createElementVNode,
  openBlock as _openBlock,
  createElementBlock as _createElementBlock,
} from "vue";

export default function render() {
  return (
    _openBlock(),
    _createElementBlock(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
      },
      [
        _createElementVNode("path", {
          "fill-rule": "evenodd",
          d: "M12 15C11.8011 15 11.6103 14.921 11.4697 14.7803L7.21967 10.5303C6.92678 10.2374 6.92678 9.76256 7.21967 9.46967C7.51256 9.17678 7.98744 9.17678 8.28033 9.46967L12 13.1893L15.7197 9.46967C16.0126 9.17678 16.4874 9.17678 16.7803 9.46967C17.0732 9.76256 17.0732 10.2374 16.7803 10.5303L12.5303 14.7803C12.3897 14.921 12.1989 15 12 15Z",
          "clip-rule": "evenodd",
        }),
      ],
    )
  );
}
